import CommonModal from "../../../App/commonModal"
import React, { useEffect, useState } from "react";
import styles from "./index.module.less";
import { Context,Hooks,Util,Request,Platform } from "@xt/xtbase";
import { Table, Space, message } from "antd";
import num from "assets/images/home/num.png";
import numIcon from "assets/images/home/numIcon.png";
import copy1 from "assets/images/home/copy1.png";
import copyIcon from "assets/images/home/copyIcon.png";
import editPng from "assets/images/home/edit.png";
import editIcon from "assets/images/home/editIcon.png";
import defaultPng from "assets/images/home/defaultPng.png";
import {put_defaultInviteCode} from "@/api/referral";
import AddInviteCodeModal from "./addInviteCodeModal";
import EditRemarkModal from "./editRemarkModal";
import InviteesModal from "./inviteesModal";
import copy from "copy-to-clipboard";
import CopyPagination from "../../../App/copyPagination"
import { FormattedMessage } from 'react-intl';

const {XtContext,XtAuth} = Context;
const {useTranslation, useDocumentWidth} = Hooks;
const {getOrigin, getUrl, getXTUrl} = Util;

function SelectiveModal (props) {
  const { isShowModal, onClose, inviteCodeList, getInviteCodeList, getProfileInfo } = props;
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const {loginStatus, lang, userInfo} = appState;
  const [messageApi, contextHolder] = message.useMessage();
  const copyToClipboard = (text) => navigator.clipboard?.writeText && navigator.clipboard.writeText(text)
  const [isShowAddModal, setIsShowAddModal] = useState(false)
  const [isShowEditModal, setIsShowEditModal] = useState(false)
  const [isShowInviteesModal, setIsShowInviteesModal] = useState(false)
  const [remark, setRemark] = useState('')
  const [id, setId] = useState(null)
  const [inviteCode, setInviteCode] = useState('')

  const [hasPrev, setHasPrev] = useState(false)
  const [hasNext, setHasNext] = useState(false)
  const [current, setCurrent] = useState(1)

  const [hoverIndex, setHoverIndex] = useState(-1)

  const onPrev = () => {
    if (current - 2 == 0) {
      setHasPrev(false)
    } else {
      setHasPrev(true)
    }
    setHasNext(true)
    setCurrent(current - 1) 
  };

  const onNext = () => {
    if ((current + 1) * 8 > inviteCodeList.length) {
      setHasNext(false)
    } else {
      setHasNext(true)
    }
    setHasPrev(true)
    setCurrent(current + 1) 

  };

  useEffect(()=>{
    if ((current) * 8 > inviteCodeList.length) {
      setHasNext(false)
    } else {
      setHasNext(true)
    }
  },[inviteCodeList.length])

  const onCloseAddModal = () => {
    setIsShowAddModal(false)
  }

  const onOkAddModal = () => {
    if(inviteCodeList.length > 19) {
      return
    }
    setIsShowAddModal(true)
  }

  const onCloseEditModal = () => {
    setIsShowEditModal(false)
  }

  const onOkEditModal = (record) => {
    setIsShowEditModal(true)
    setRemark(record.remark)
    setId(record.id)
  }

  const onCloseInviteesModal = () => {
    setIsShowInviteesModal(false)
  }

  const onOkInviteesModal = (record) => {
    setIsShowInviteesModal(true)
    setInviteCode(record.inviteCode)
  }

  // 复制链接
  const onCopyLink = (copyLinkUrl) => {
    copy(copyLinkUrl);
    messageApi.open({
      type: 'success',
      content: t("home.copySuccess"),
    });
  };

  const defaultInit = (id) => {
    put_defaultInviteCode({
      successPop: true,
      data:{id}
    }).then(()=>{
      getProfileInfo()
      getInviteCodeList()
    })
  }

  const getRootDomain = () => {
    let domain = document.domain;//先获取当前访问的全域名
    let domain2 = domain.substring(domain.indexOf('.')+1);//截取第一个点的位置来获取根域名,这样只能获取二级域名的根域名，如果直接是不带www的域名访问，那么就会直接获取域名的后缀
    return domain2
  }

  const columns = [
    {
      title: t("home.invitationCode"),
      dataIndex: 'inviteCode',
      key: 'inviteCode',
    },
    {
      title: t("home.myPercentage"),
      dataIndex: 'selfCommissionRate',
      key: 'selfCommissionRate',
      render: (_, record) => (
        <Space size="middle">
          <span>{(record.selfCommissionRate * 100).toFixed(0) + '%'}</span>
        </Space>
      ),
    },
    {
      title: t("home.youPercentage"),
      dataIndex: 'inviteeCommissionRate',
      key: 'inviteeCommissionRate',
      render: (_, record) => (
        <Space size="middle">
          <span>{(record.inviteeCommissionRate * 100).toFixed(0) + '%'}</span>
        </Space>
      ),
    },
    {
      title: t("home.inviteNum"),
      dataIndex: 'inviteNum',
      key: 'inviteNum',
      render: (_, record, index) => (
        <div className="rowItem">
          <img onMouseEnter={()=>setHoverIndex(`${_}${index}`)} onMouseLeave={()=>setHoverIndex(-1)}  onClick={()=>onOkInviteesModal(record)} src={hoverIndex == `${_}${index}` ? numIcon : num} />
          <span>{record.inviteNum}</span>
        </div>
      ),
    },
    {
      title: t("home.referralUrl"),
      dataIndex: 'referralUrl',
      key: 'referralUrl',
      render: (_, record, index) => (
        <div className="rowItem">
          <img onMouseEnter={()=>setHoverIndex(`${_}${index}`)} onMouseLeave={()=>setHoverIndex(-1)} src={hoverIndex == `${_}${index}` ? copyIcon : copy1} onClick={()=>onCopyLink(`${process.env.NEXT_PUBLIC_protocol}//www.${getRootDomain()}/${lang}/accounts/register?ref=${record.inviteCode}`)}  />
          <span>{`${process.env.NEXT_PUBLIC_protocol}//www.${getRootDomain()}/${lang}/accounts/register?ref=${record.inviteCode}`}</span>
        </div>
      ),
    },
    {
      title: t("home.remark"),
      dataIndex: 'remark',
      key: 'remark',
      render: (_, record, index) => (
        <div className="rowItem">
          <img onMouseEnter={()=>setHoverIndex(`${_}${index}`)} onMouseLeave={()=>setHoverIndex(-1)} src={hoverIndex == `${_}${index}` ? editIcon : editPng} onClick={()=>onOkEditModal(record)} />
          <span>{record.remark}</span>
        </div>
      ),
    },
    {
      title: t("home.action"),
      key: 'action',
      render: (_, record,index) => (
        <div className="rowItemAction">
          {record.isDefault && <img src={defaultPng} />}
          {record.isDefault && <span>{t("home.default1")}</span>}
          {!record.isDefault && <span onClick={()=>defaultInit(record.id)} style={{ color: '#0075FF', cursor: 'pointer' }}>{t("home.default1")}</span>}
        </div>
      ),
    },
  ];

  return (
    <>
      <CommonModal width={1000} title={t("home.selective")} isShowModal={isShowModal} onClose={onClose}>
      {contextHolder}
        <div className="selectiveModal">
          <div className="selective">
            <div className="selectiveHL">
              <FormattedMessage
                id="home.createNumberTip"
                values={{
                  created: <span>{inviteCodeList.length}</span>,
                  remain: <span>{20 - inviteCodeList.length}</span>,
                }}
              />
            </div>
            <div className="selectiveHR" onClick={onOkAddModal}>{t("home.addNew")}</div>
          </div>
          <Table pagination={false} size="small" dataSource={inviteCodeList.slice((current-1)*8, current*8)} columns={columns} />
          {inviteCodeList.length != 0 && <div className="pagination">
            <CopyPagination
              position="center"
              hasPrev={hasPrev}
              hasNext={hasNext}
              onPrev={onPrev}
              onNext={onNext}
              isActivePage={true}
            />
          </div>}
        </div>
        <div className="foot">
          <div className="cancel" onClick={onClose}>{t("home.cancel")}</div>
          <div className="sure" onClick={onClose}>{t("home.sure")}</div>
        </div>
      </CommonModal>
      <AddInviteCodeModal isShowModal={isShowAddModal} onClose={onCloseAddModal} getInviteCodeList={getInviteCodeList} />
      {isShowEditModal && <EditRemarkModal isShowModal={isShowEditModal} onClose={onCloseEditModal} getInviteCodeList={getInviteCodeList} remark={remark} id={id} />}
      {isShowInviteesModal && <InviteesModal isShowModal={isShowInviteesModal} onClose={onCloseInviteesModal} getInviteCodeList={getInviteCodeList} inviteCode={inviteCode} />}
    </>
  )
}


export default SelectiveModal